// extracted by mini-css-extract-plugin
export default {"tagCell":"Cell_tagCell__wX2dv"};